define('models/base/widget',['require','models/base/subscribe'],function(require) {
    'use strict';

    var SubscribeModel = require('models/base/subscribe');

    var WidgetModel = SubscribeModel.extend({
    });

    return WidgetModel;
});
